import { useUploadProfilePictureCommand } from 'legacy/user/hooks';

import UploadPhotoButton from './UploadPhotoButton';

type UploadProfilePictureButtonProps = {
  label?: string;
  onUpload: (url: string) => void;
  ButtonComponent?: React.FC<{ onClick: () => void }>;
};

const UploadProfilePictureButton: React.FC<UploadProfilePictureButtonProps> = ({
  label,
  onUpload,
  ButtonComponent
}) => {
  const uploadProfilePictureCommand = useUploadProfilePictureCommand();

  return (
    <UploadPhotoButton
      label={label}
      ButtonComponent={ButtonComponent}
      isLoading={uploadProfilePictureCommand.isLoading}
      errorMessage={uploadProfilePictureCommand.error?.message}
      uploadPhoto={async (blob) => {
        await uploadProfilePictureCommand.mutateAsync(blob, {
          onSuccess: (data) => {
            onUpload(data.photo);
          }
        });
      }}
    />
  );
};

export default UploadProfilePictureButton;
